export default __webpack_public_path__ + "static/media/strong 4 live class.5e7a8bb9.png";